export const MARKETING_EMAIL_CONSENT_LABEL =
  'Email me tips, breed guides and offers from Paction. I can unsubscribe at any time.';

export const MARKETING_EMAIL_CONSENT_VERSION = '2026-10-14';

export const MARKETING_EMAIL_CONSENT_SOURCES = [
  'purchaser_signup',
  'global_waitlist'
] as const;

export type MarketingEmailConsentSource =
  (typeof MARKETING_EMAIL_CONSENT_SOURCES)[number];

export type MarketingEmailConsent = {
  optedInAt: string;
  source: MarketingEmailConsentSource;
  wording: string;
  version: string;
};

export const buildMarketingEmailConsent = (
  source: MarketingEmailConsentSource,
  now: Date
): MarketingEmailConsent => ({
  optedInAt: now.toISOString(),
  source,
  wording: MARKETING_EMAIL_CONSENT_LABEL,
  version: MARKETING_EMAIL_CONSENT_VERSION
});
